export default __webpack_public_path__ + "static/media/daniel caeser - cyanide sample.8ef4b308.wav";